import React, { useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "repo/get";
import usePutData from "repo/put";
import ReactHowler from "react-howler";
import positiveSound from "assets/positive.mp3";
import negativeSound from "assets/negative.mp3";

const CardDataTable = () => {
    const cargoSelect = localStorage.getItem("cargo") || "";
    const baseSelect = localStorage.getItem("baseSelected") || "";

    const [isSubmittingRecebimento, setIsSubmittingRecebimento] = useState(false);
    const [recebimentoSucesso, setRecebimentoSucesso] = useState(null);
    const [recebimentoError, setRecebimentoError] = useState(null);
    const [codigoRecebimento, setCodigoRecebimento] = useState("");
    const [playSound, setPlaySound] = useState(null);
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    
    const { putData } = usePutData();

    const handleAdicionarRomaneio = async () => {
        if (!codigoRecebimento) {
          setError("Por favor, preencha o código do romaneio.");
          setPlaySound(negativeSound);
          return;
        }
    
        setIsSubmittingRecebimento(true);
    
        try {
          const response = await putData(`api/romaneios/update/codigo/unblock/${codigoRecebimento}`, {
            motorista: 0,
            status: "aguardando",
            base: baseSelect
          });
    
          if (response && response.message) {
            setError(response.message);
            setPlaySound(negativeSound);
          } else if (response && response.id) {
            const newRomaneio = {
              id: response.id,
              codigoUid: response.codigoUid,
              quantidade: response.quantidade,
              empresa: response.empresa.nome,
              entregador: response.entregador.nome,
              endereco: response.entregador.endereco,
              funcionario: response.funcionario.nome,
              local: response.cidade.map((cidade) => cidade.nome).join(', '),
              base: response.base.nome,
              sts: response.sts,
              codigos: response.codigos,
              telefone: response.entregador.telefone,
              linkDownload: response.linkDownload,
              data: response.data.replace("T", " ").split(".")[0] || new Date().toISOString(),
            };
    
            setData((prevData) => {
              const exists = prevData.some((item) => item.id === newRomaneio.id);
              if (exists) {
                return prevData;
              }
              return [newRomaneio, ...prevData];
            });
    
            setPlaySound(positiveSound);
            setError("");
            setRecebimentoSucesso("Romaneio desbloqueado com sucesso!, romaneio: " + newRomaneio.codigoUid + " agora estara disponivel para ser movimentado.");
          } else {
            setError("Erro desconhecido ao tentar atualizar o romaneio.");
            setPlaySound(negativeSound);
          }
        } catch (err) {
          setError("Erro ao atualizar romaneio.");
          setPlaySound(negativeSound);
        } finally {
          setIsSubmittingRecebimento(false);
          setCodigoRecebimento("");
        }
      };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleAdicionarRomaneio();
        }
    };

    return (
        <div className="table-header w-full">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 w-full">
                {/* Bloco de Recebimento */}
                <div className="relative flex m-4 flex-col items-center justify-center w-full min-w-0 break-words shadow-lg rounded-lg bg-white p-6">
                    <h1 className="text-2xl font-bold p-component ">DESBLOQUEAR</h1>
                    <span className="text-sm font-bold p-component mb-2">
                        Insira o código do romaneio para desbloquear do status como "FINALIZADO" ou "INATIVO"
                    </span>
                    <div className="mb-4 m-4">
                        <i className="fa fa-flag" style={{ fontSize: "15rem" }}></i>
                    </div>
                    {cargoSelect !== "ENTREGADOR" && (
                        <input
                            type="text"
                            placeholder="Adicionar romaneio ..."
                            value={codigoRecebimento}
                            onChange={(e) => setCodigoRecebimento(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="p-inputtext p-component rounded-md shadow px-4 py-2 border border-black w-full"
                        />
                    )}
                    {recebimentoError && <p className="m-4 text-red-500">{recebimentoError}</p>}
                    {recebimentoSucesso && <p className="m-4 text-emerald-500">{recebimentoSucesso}</p>}
                    {error && <p className="m-4 text-red-500">{error}</p>}
                </div>
            </div>
            {/* Mensagens de som */}
            <div className="w-full mt-4">
                {playSound && (
                    <ReactHowler
                        src={playSound}
                        playing={true}
                        onEnd={() => setPlaySound(null)}
                    />
                )}
            </div>
        </div>
    );
};

export default CardDataTable;
